import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../utility/axios';
import queryString from 'query-string';
import TrackInput from './TrackInput';
import TrackResults from './TrackResults';
import TrackMessage from './TrackMessage';
import { useStateValue } from '../context/stateContext';
import { TRACK_API_ENDPOINT } from '../const/endpoint';
import Heading from './Heading';
import { getApiErrorMessage } from '../utility/apiError';

const TrackPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { number } = queryString.parse(location.search);
  const [isLoading, setLoading] = useState(false);
  const [trackingResults, setTrackingResults] = useState([]);
  const [errorMessage, setErrorMessage] = useState(
    'Unesite broj za praćenje i kliknite na dugme „Prati“.',
  );
  const [{ loggedUser }] = useStateValue();

  useEffect(() => {
    const robotsMeta = document.querySelector('meta[name="robots"]');

    if (robotsMeta) {
      robotsMeta.setAttribute(
        'content',
        number ? 'noindex, follow' : 'index, follow',
      );
    }
  }, [number]);

  const handleSubmit = async (trackingNumber) => {
    setLoading(true);
    setErrorMessage('');
    setTrackingResults([]);
    navigate({ search: `?number=${trackingNumber}` });

    try {
      const response = await axios.get(
        `${TRACK_API_ENDPOINT}?number=${trackingNumber}`,
      );
      setTrackingResults(response.data);
    } catch (error) {
      setErrorMessage(
        getApiErrorMessage(error, {
          context: 'tracking',
          fallback: `Podaci za praćenje nisu pronađeni za broj „${trackingNumber}“.`,
        }),
      );
      setTrackingResults({});
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tracking-app">
      <header className="header-container">
        <Heading />
        <div
          className={
            loggedUser.isLoggedIn
              ? 'track-input-container'
              : 'track-input-container-not-logged'
          }
        >
          <TrackInput
            onSubmit={handleSubmit}
            isLoading={isLoading}
            number={number}
          />
        </div>
      </header>
      <main className="track-page-container">
        {!!Object.keys(trackingResults).length && (
          <TrackResults trackingResults={trackingResults} />
        )}
        {!Object.keys(trackingResults).length && errorMessage && (
          <TrackMessage message={errorMessage} />
        )}
      </main>
    </div>
  );
};

export default TrackPage;
